import {
  alpha,
  Box,
  Chip,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useContext } from 'react';

import { ApplicationCount, ApplicationStatus } from '@features/applications';
import { getStatusChipColor } from '@features/applications/components/ApplicationListItem/utils';
import StaffLevelCopy from '@features/employerTeam/components/StaffLevelCopy';
import { authContext } from '@staffedupusa/shared-components';

type ApplicationsCountsListItemProps = {
  applicationCount: ApplicationCount;
  selected: boolean;
  disabled: boolean;
  handleTogglePosition: (title?: string) => void;
  handlePageNo: (newPageNo: number) => void;
};

const ApplicationsCountsListItem: FC<ApplicationsCountsListItemProps> = ({
  applicationCount,
  selected,
  disabled,
  handleTogglePosition,
  handlePageNo,
}) => {
  const { authData } = useContext(authContext);

  const createChip = (value: number, status: ApplicationStatus) => {
    if (!value) {
      return null;
    }

    return (
      <Chip
        label={value}
        size="small"
        sx={{
          bgcolor: alpha(getStatusChipColor(status), 0.2),
          color: getStatusChipColor(status),
          height: 'auto',
        }}
      />
    );
  };
  return (
    <ListItem
      sx={{
        px: 3,
        py: 0,
      }}
      selected={selected}
    >
      <ListItemButton
        disabled={disabled}
        onClick={() => {
          handlePageNo(1);
          handleTogglePosition(applicationCount.s_title);
        }}
      >
        <ListItemText
          primaryTypographyProps={{
            fontSize: '15px',
            fontWeight: selected ? 'bold' : 'normal',
          }}
          primary={
            <Box display="flex" alignItems="center" gap={1}>
              {applicationCount.s_title !== 'All' &&
                authData?.user?.company && (
                  <StaffLevelCopy applicationCount={applicationCount} />
                )}
              <Typography>{applicationCount.s_title}</Typography>
            </Box>
          }
        />
        <Stack spacing={1} direction="row">
          {createChip(applicationCount.unattended, 'unattended')}
          {createChip(applicationCount.messaged, 'messaged')}
          {createChip(applicationCount.attended, 'attended')}
          {createChip(applicationCount.interview_process, 'interview process')}
        </Stack>
      </ListItemButton>
    </ListItem>
  );
};

export default ApplicationsCountsListItem;
